export const documentTypes = {
  "Central Database": [
    "Aadhaar Card", "PAN Card", "Passport", "Voter ID", "Driving License",
    "Vehicle RC", "ITR", "Form 16", "GST Certificate", "EPFO Passbook",
    "ESI Card", "Pension Document", "Ration Card", "Arms License", "Import Export License",
    "FSSAI License", "Drug License", "Certificate of Origin", "Bill of Entry", "Shipping Bill", "Customs Clearance"
  ],
  "State Database": [
    "Domicile Certificate", "Income Certificate", "Caste Certificate", "Birth Certificate", "Death Certificate",
    "Marriage Certificate", "Land Records (7/12, 8A)", "Property Tax Receipt", "Sale Deed", "Encumbrance Certificate",
    "NOC", "Trade License", "Shop Act License", "Building Permit", "Occupancy Certificate",
    "Water Connection", "Electricity Bill", "Sewage Connection", "Fire NOC", "Environment Clearance", "BPL Card"
  ],
  "Entity/Corporate": [
    "Certificate of Incorporation", "CIN", "Company PAN", "GST Registration", "MSME Registration",
    "TAN", "Import Export Code", "Udyam Certificate", "Startup Recognition", "MOA/AOA",
    "Board Resolution", "Shareholder Agreement", "Employment Contract", "Vendor Agreement", "Client Contract",
    "NDA", "Partnership Deed", "LLP Agreement", "Trust Deed", "Society Registration", "Section 8 Company Certificate"
  ],
  "Educational": [
    "10th Marksheet", "12th Marksheet", "Graduation Degree", "Post Graduation Degree", "Diploma Certificate",
    "Professional Degree (CA/CS/CMA)", "Technical Certificate", "Skill Certificate", "Migration Certificate", "Transfer Certificate",
    "Bonafide Certificate", "Gap Certificate", "Character Certificate", "Medium of Instruction Certificate"
  ],
  "Banking & Financial": [
    "Bank Statement", "Loan Agreement", "Fixed Deposit Receipt", "Mutual Fund Statement", "Demat Account Statement",
    "Credit Card Statement", "Cancelled Cheque", "KYC Documents", "CIBIL Report", "Insurance Policy",
    "Premium Receipt", "Claim Document", "Investment Proof", "Tax Savings Certificate", "NRI Documents", "FEMA Documents"
  ],
  "Medical & Health": [
    "Medical Certificate", "Vaccination Certificate", "COVID Certificate (CoWIN)", "Disability Certificate", "Fitness Certificate",
    "Blood Test Report", "X-Ray Report", "Prescription", "Hospital Discharge Summary", "Health Insurance Card",
    "Medical History", "Organ Donor Card"
  ],
  "Employment": [
    "Appointment Letter", "Offer Letter", "Experience Certificate", "Salary Slip", "Form 16",
    "PF Statement", "Gratuity Document", "Resignation Letter", "Relieving Letter", "Service Certificate",
    "Performance Appraisal", "Bond Agreement"
  ],
  "Legal & Court": [
    "Court Order", "Judgment Copy", "FIR Copy", "Chargesheet", "Bail Order",
    "Legal Notice", "Power of Attorney", "Will Document", "Succession Certificate", "Legal Heir Certificate",
    "Arbitration Award", "Settlement Deed", "Decree Copy", "Contempt Notice", "Police Verification"
  ],
  "Transport & Vehicle": [
    "Vehicle Insurance", "Vehicle Permit", "Fitness Certificate", "PUC Certificate", "Hypothecation Termination",
    "Road Tax Receipt", "Vehicle Transfer NOC", "Vehicle Loan Closure", "Accident Report", "Vehicle Inspection Report"
  ],
  "Miscellaneous": [
    "Passport Size Photo", "Signature", "Thumb Impression", "Address Proof", "Identity Proof",
    "Age Proof", "Relationship Proof", "Utility Bill", "Rent Agreement", "Leave & License Agreement",
    "Affidavit", "Indemnity Bond", "Undertaking", "Declaration", "Letter of Intent",
    "Reference Letter", "Recommendation Letter", "Other Document"
  ]
};
